__turbopack_context__.v({
  "button-content": "SSOLoginButton-module-scss-module__LU5qIW__button-content",
  "logo": "SSOLoginButton-module-scss-module__LU5qIW__logo",
  "precedence-hack": "SSOLoginButton-module-scss-module__LU5qIW__precedence-hack",
  "sso-login-button": "SSOLoginButton-module-scss-module__LU5qIW__sso-login-button",
  "text": "SSOLoginButton-module-scss-module__LU5qIW__text",
});
